import { schema } from 'normalizr';

export const contract = new schema.Entity('contracts');
export const contracts = [contract];
